export const CONCIERGE_WAIT_DAYS = 3;
